import React from 'react';
import { Button, Card, Descriptions, Space, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import './Dashboard.css';

const { Title } = Typography;

const Dashboard: React.FC = () => {
  const { user, logout, logoutAll } = useAuth();
const navigate = useNavigate();

  const moveTo = () => {
    // your logout logic here

    navigate("http://localhost:4801"); // navigates to http://localhost:4800/universe
  };
  return (
    <div className="dashboard-container">
      <Card className="dashboard-card">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div className="dashboard-header">
            <UserOutlined className="user-icon" />
            <Title level={2}>Welcome, {user?.name || user?.user_name}!</Title>
          </div>

          <Descriptions title="User Information" bordered column={1}>
            <Descriptions.Item label="Username">{user?.user_name}</Descriptions.Item>
            <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
            <Descriptions.Item label="Company ID">{user?.company_id || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Status">
              {user?.status ? 'Active' : 'Inactive'}
            </Descriptions.Item>
          </Descriptions>

          <Space>
            <Button type="primary" danger onClick={logout} icon={<LogoutOutlined />}>
              Logout
            </Button>
            <Button danger onClick={logoutAll} icon={<LogoutOutlined />}>
              Logout from All Devices
            </Button>
             <Button danger onClick={moveTo} icon={<LogoutOutlined />}>
             Universe
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
};

export default Dashboard;
